import {useCallback, useMemo} from 'react';
import {useAppDispatch, useAppSelector} from '../store/hooks';
import {setPlayerSessionFilter} from '../store/playerSessionSlice';
import {PlayerSessionFilterForm} from '../components/shared/PlayerSessionFilter';
import {
  filterPlayerSessions,
  getUniquePlayerSessionTeams,
} from '../services/playerSessionService';

/**
 * Reads the player sessions in the store and applies the shared session filter
 * to them. Both the Player Sessions page and the Player Dashboard sessions tab
 * render the same filter + list pair, so they share this wiring.
 */
const usePlayerSessionFilter = () => {
  const dispatch = useAppDispatch();
  const playerSessions = useAppSelector(
    state => state.playerSession?.playerSessions,
  );
  const filter = useAppSelector(
    state => state.playerSession?.playerSessionFilter,
  );
  const loading = useAppSelector(
    state => state.playerSession?.status === 'loading',
  );

  const filteredPlayerSessions = useMemo(
    () =>
      filter
        ? filterPlayerSessions(playerSessions ?? [], filter)
        : playerSessions ?? [],
    [playerSessions, filter],
  );

  const teams = useMemo(
    () => getUniquePlayerSessionTeams(playerSessions ?? []),
    [playerSessions],
  );

  const onFilterUpdate = useCallback(
    (filterData: PlayerSessionFilterForm) => {
      dispatch(setPlayerSessionFilter(filterData));
    },
    [dispatch],
  );

  return {filteredPlayerSessions, teams, filter, loading, onFilterUpdate};
};

export default usePlayerSessionFilter;
